import React, { Component } from "react";
import { connect } from "react-redux";

import './PromoterInfo.sass';
import { getPromoterInfo } from "../../../../store/actions/promoterActions";
import { currencies } from "../../../../constants/currencies";

class PromoterInfo extends Component {
  state = {
    name: '',
    email: '',
    address: '',
    companyName: '',
    website: '',
    feeSettings: {
      rate: 0,
      fixedByPosition: 0,
      fixedByOrder: 0
    },
    currencyId: null,
  }

  componentDidMount() {
    const { getPromoterInfo, user } = this.props;

    getPromoterInfo(user.token)
      .then(data => this.setState({...data}));
  }

  render() {
    const {
      name,
      email,
      address,
      companyName,
      website,
      feeSettings,
      currencyId
    } = this.state;

    const currency = currencies.find(
      (option) => option.value === currencyId,
    );

    const currencyLabel = currency ? currency.label : '';
    

    return (
      <div className="promoter-info info">
        <div className="add-event__row">
          <div className="add-event__column">
            <div className="add-event__block">
              <label>Name</label>
              <span className="add-event__block__count">
                {name}
              </span>
            </div>
          </div>

          <div className="add-event__column">
            <div className="add-event__block">
              <label>Email</label>
              <span className="add-event__block__count">
                {email}
              </span>
            </div>
          </div>

          <div className="add-event__column">
            <div className="add-event__block">
              <label>Address</label>
              <span className="add-event__block__count">
                {address}
              </span>
            </div>
          </div>
        </div>

        <div className="add-event__row">
          <div className="add-event__column">
            <div className="add-event__block">
              <label>Company name</label>
              <span className="add-event__block__count">
                {companyName}
              </span>
            </div>
          </div>

          <div className="add-event__column">
            <div className="add-event__block">
              <label>Website</label>
              <span className="add-event__block__count">
                {website}
              </span>
            </div>
          </div>
        </div>

        <div className="add-event__row">
          <div className="add-event__column">
            <div className="add-event__block">
              <label>Fee rate, %</label>
              <span className="add-event__block__count">
                {((feeSettings && feeSettings.rate) || 0) * 100}
              </span>
            </div>
          </div>

          <div className="add-event__column">
            <div className="add-event__block">
              <label>Fixed by position fee, {currencyLabel}</label>
              <span className="add-event__block__count">
                {(feeSettings && feeSettings.fixedByPosition) || 0}
              </span>
            </div>
          </div>

          <div className="add-event__column">
            <div className="add-event__block">
              <label>Fixed by order fee, {currencyLabel}</label>
              <span className="add-event__block__count">
                {(feeSettings && feeSettings.fixedByOrder) || 0}
              </span>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = ({
  auth: { user },
}) => ({ user });

const mapDispatchToProps = (dispatch) => ({
  getPromoterInfo: (token) => dispatch(getPromoterInfo(token)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PromoterInfo);
